export const fieldModel = {
   'name': {
      'title': "Name",
      'display': true
   },
   'type': {
      'title': "Type",
      'display': true
   },
   'options': {
      'title': "Options",
      'display': false
   },
   'required': {
      'title': "Required?",
      'display': false
   },
   'use_for_availability': {
      'title': "Use for Availability?",
      'display': false
   },
   'value_in_list': {
      'title': "Value in List?",
      'display': false
   }
};